const knownModules: Map<string, any> = new Map<string, any>();
export function registerModule(moduleName: string, module: any) {
    if (knownModules.has(moduleName)) {
        console.error(`Module ${moduleName} already registered.`);
    }
    else {
        knownModules.set(moduleName, module);
    }
    
}
export function getModule(moduleName: string): any {
    if (knownModules.has(moduleName)) {
        return knownModules.get(moduleName);
    }
    return null;
}